/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

/**
* THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
*/
'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

require('babel/polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _historyLibCreateBrowserHistory = require('history/lib/createBrowserHistory');

var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);

var _scrollBehaviorLibUseStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _scrollBehaviorLibUseStandardScroll2 = _interopRequireDefault(_scrollBehaviorLibUseStandardScroll);

var _reduxCreate = require('./redux/create');

var _reduxCreate2 = _interopRequireDefault(_reduxCreate);

var _helpersApiClient = require('./helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _helpersMakeRouteHooksSafe = require('./helpers/makeRouteHooksSafe');

var _helpersMakeRouteHooksSafe2 = _interopRequireDefault(_helpersMakeRouteHooksSafe);

var client = new _helpersApiClient2['default']();

// Three different types of scroll behavior available.
// Documented here: https://github.com/rackt/scroll-behavior
var scrollableHistory = _scrollBehaviorLibUseStandardScroll2['default'](_historyLibCreateBrowserHistory2['default']);

var dest = document.getElementById('content');
var store = _reduxCreate2['default'](_reduxRouter.reduxReactRouter, _helpersMakeRouteHooksSafe2['default'](_routes2['default']), scrollableHistory, client, window.__data);

var component = _react2['default'].createElement(_reduxRouter.ReduxRouter, { routes: _routes2['default'](store) });

_reactDom2['default'].render(_react2['default'].createElement(
	_reactRedux.Provider,
	{ store: store, key: 'provider' },
	component
), dest);

if (process.env.NODE_ENV !== 'production') {
	window.React = _react2['default']; // enable debugger

	if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
		console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
	}
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
	var DevTools = require('./containers/DevTools/DevTools');
	_reactDom2['default'].render(_react2['default'].createElement(
		_reactRedux.Provider,
		{ store: store, key: 'provider' },
		_react2['default'].createElement(
			'div',
			null,
			component,
			_react2['default'].createElement(DevTools, null)
		)
	), dest);
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/client.js
 ** module id = 0
 ** module chunks = 0
 **/